import React from "react";
import "../Css/OurTeachers.css";

import t1 from "../assets/Chemistry_Sir.png";
import t2 from "../assets/ashish.jpeg";
import t3 from "../assets/Biology_Mam.png";
import t4 from "../assets/asitlal.jpg";
import t5 from "../assets/Chirag_Sir.jpeg";

const teachers = [
  {
  img: t4,
  name: "Asit Sir",
  subject: "MATHS, PHYSICS",
  desc:
    "Mathematics and Physics build strong logical thinking and problem-solving abilities in students. Mathematics strengthens concepts in algebra, geometry, calculus, and reasoning, while Physics develops understanding of motion, force, energy, and real-world scientific principles. A strong foundation in these subjects is essential for board exams and competitive exams like JEE and other entrance tests."
},
{
    img: t3,
    name: "Amrita Mam",
    subject: "BIOLOGY, CHEMISTRY, MATHS",
    desc:
      "These subjects together build a strong base for medical and engineering entrance exams. Biology explains living systems and human health, Chemistry focuses on reactions and molecular behavior, while Mathematics strengthens analytical skills. A balanced approach ensures better understanding and high performance in exams."
  },
  {
    img: t1,
    name: "Dhruv Sir",
    subject: "CHEMISTRY",
    desc:
      "Chemistry helps students understand the composition, structure, and reactions of matter. The subject builds strong foundations in physical, organic, and inorganic chemistry, which are essential for board exams as well as competitive exams like NEET and IIT-JEE. Regular practice of numericals, equations, and mechanisms improves analytical and problem-solving skills."
  },
  {
    img: t2,
    name: "Ashish Sir",
    subject: "MATHS",
    desc:
      "Mathematics develops logical thinking and problem-solving ability. Topics like algebra, calculus, trigonometry, and coordinate geometry are crucial for academic excellence and competitive examinations. Consistent practice and conceptual clarity help students improve speed, accuracy, and confidence."
  },
  {
  img: t5,
  name: "Chirag Sir",
  subject: "CHEMISTRY",
  desc:
    "I have 12 years experience in chemistry of 11th , 12th  and competitive exams. I teach  cbse , gseb ,icse boards.Chemistry builds a strong foundation for competitive exams by focusing on concepts like chemical reactions, bonding, thermodynamics, and molecular structure. It helps students understand how substances interact and transform in real-world applications."
}
];



const OurTeachers = () => {
  return (
    <section className="teachers">
      <h2 className="teachers-title">Our Experienced Teachers</h2>

      <div className="teachers-container">
        {teachers.map((t, i) => (
          <div className="teacher-card" key={i}>
            <div className="teacher-img">
              <img src={t.img} alt={t.name} />
            </div>

            <h3>{t.name}</h3>
            <span className="subject">{t.subject}</span>

            <div className="line"></div>

            <p>{t.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default OurTeachers;
